module.exports = __webpack_public_path__ + "images/preview_large@1x.png?d53721a8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preview_large@1x.png
// module id = 686
// module chunks = 7